// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.toggle-control[data-v-aee07a2e] {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  border: 1px solid #e0e0e0;\r\n  padding: 5px 10px;\r\n  border-radius: 8px;\n}\n.toggle-control .text-h6[data-v-aee07a2e] {\r\n  color: black;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
